function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#042b62",
    d: "M 127.5,59.5 C 127.5,62.1667 127.5,64.8333 127.5,67.5C 110.673,84.1603 93.6728,100.66 76.5,117C 69.0482,116.727 64.3815,112.893 62.5,105.5C 65.9726,98.349 70.9726,92.349 77.5,87.5C 82.5734,83.9344 87.2401,79.7677 91.5,75C 91.2716,74.6012 90.9382,74.4346 90.5,74.5C 61.3362,73.6677 32.0029,73.1677 2.5,73C 1.62656,71.955 0.626561,71.1217 -0.5,70.5C -0.5,65.8333 -0.5,61.1667 -0.5,56.5C 0.626561,55.8783 1.62656,55.045 2.5,54C 31.8333,53.6667 61.1667,53.3333 90.5,53C 80.9695,43.8037 71.8029,34.3037 63,24.5C 62.7676,16.547 66.6009,11.547 74.5,9.5C 75.938,9.71893 77.2713,10.2189 78.5,11C 94.7014,27.3685 111.035,43.5351 127.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.588
    },
    fill: "#868a88",
    d: "M 90.5,74.5 C 90.9382,74.4346 91.2716,74.6012 91.5,75C 87.2401,79.7677 82.5734,83.9344 77.5,87.5C 81.5,82.8333 85.8333,78.5 90.5,74.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.700c463b1b64233414970b88f3d1dfcb.svg";
export { ForwardRef as ReactComponent };